// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22ylh","left":"styles_left__dhs2h","right":"styles_right__1qUe7","alert":"styles_alert__1hwXn"};